import React, { useState } from 'react'

import { Tabs, Card, Button, Form } from 'antd';
import ScheduleAndChargeDetail from './ScheduleAndChargeDetail'
import ScheduleAndChargeEdit from './ScheduleAndChargeEdit'
import moment from 'moment';
import PageContainer from '../../../CSIComponents/PageContainer';

const { TabPane } = Tabs;

interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    disableTabPanes?: void | any,
    detail?: any,
    cancelAndSave?: void | any,
    tableCurrentData?: any,
    scheduleAndChargeData?: void | any,
    editData?: void | any,
    handelCancelBtnClick?: void | any,
    setDisabledFlag?: any

}
const ScheduleAndCharge = (props: propsTypes) => {
    console.log(props)
    const [form] = Form.useForm();
    const [editFlag, setEditFlag] = useState(false);
    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ margin: '0 10px 0 0' }}>
                <Button className="db-edit-btn" onClick={() => { props.cancelAndSave(); }}>Back</Button>
            </div>
            <div>
                <Button className='db-edit-btn' type='primary' onClick={() => { setEditFlag(!editFlag); props.isEditable(); props.setDisabledFlag(true) }}>Edit</Button>
                    </div>
        </div>
    }

    const saveAndCancel = <>
        <Button type='primary' style={{ background: '#dc3545', borderColor: '#dc3545' }} onClick={() => { setEditFlag(!editFlag); props.cancelEditable(); }}>Cancel</Button>
        <Button type='primary' onClick={() => { setEditFlag(!editFlag) }} style={{ marginLeft: 10 }}>Save</Button>
    </>
    const editPageCancelBtnClick = () => {
        setEditFlag(false);
        props.cancelEditable();
    }
    const setEditToDetail = () => {
        setEditFlag(false);
        setEditFlag(!editFlag); props.cancelEditable(); 
    }
    const itemFormat = 'HH:mm';
    let detailPageData = JSON.parse(JSON.stringify(props.scheduleAndChargeData.schedule))

    detailPageData.forEach((item: any, index: number) => {
        item?.operationtime?.forEach((cell: any, oIndex: any) => {
            if (cell.starttime != null && typeof (cell.starttime) === 'object') {
                cell.starttime = moment(cell.starttime, itemFormat)
            } else if (typeof (cell.starttime) != 'object' && cell.starttime) {
                cell.starttime = cell.starttime
            } else {
                cell.starttime = ""
            }
        })
    })
    const [detailData, setDetailData] = useState(detailPageData);
    const gerEditData = (data: any) => {
        setDetailData(data)
        props.setDisabledFlag(false)
    }
    const cancelAndSaveBtn = () => {
        props.setDisabledFlag(false)
    }

    const [activeKey, setActiveKey] = useState(1)
    const getClickTabs = (data: any) => {
        console.log(activeKey)
        setActiveKey(data)
    }
    const data = JSON.parse(JSON.stringify(detailData))
    data.forEach((item: any) => {
        item.startdate === null ? item.startdate = "" : item.startdate = item.startdate
        item.startdate === null ? item.enddate = "" : item.enddate = item.enddate
        item?.operationtime?.forEach((cell: any) => {
            if (cell.starttime != null && typeof (cell.starttime) === 'object') {
                cell.starttime = moment(cell.starttime, itemFormat)
            } else if (typeof (cell.starttime) != 'object' && cell.starttime && cell.starttime.length < 10) {
                cell.starttime = cell.starttime
            } else if (cell.starttime.length > 10) {
                let startH = new Date(cell.starttime).getHours()
                let startM = new Date(cell.starttime).getMinutes()

                let endH = new Date(cell.endtime).getHours()
                let endM = new Date(cell.endtime).getMinutes()
                cell.starttime = ('0' + startH).slice(-2) + ':' + ('0' + startM).slice(-2) + ''
                cell.endtime = ('0' + endH).slice(-2) + ':' + ('0' + endM).slice(-2) + ''
            } else {
                cell.starttime = ""
            }
        })
    })
    return (
        <>{!editFlag ? <PageContainer>
            <Card style={{ marginBottom: '60px' }}>
                <Tabs defaultActiveKey="1" type="card" tabBarExtraContent={editFlag ? saveAndCancel : edit()}>
                    {data.map((item: any, index: any) => {
                        return (

                            <TabPane tab={'Schedule ' + (index + 1)} key={index + 1}>
                                <Card>
                                    <ScheduleAndChargeDetail detailData={item} />
                                </Card>
                            </TabPane>
                        )

                    })}
                </Tabs>
            </Card>
        </PageContainer> :

            <ScheduleAndChargeEdit cancelAndSave={props.cancelAndSave} setEditToDetail={setEditToDetail} cancelAndSaveBtn={cancelAndSaveBtn} gerEditData={gerEditData} cancelEditable={props.cancelEditable} info={props.scheduleAndChargeData} setDisabledFlag={props.setDisabledFlag} getClickTabs={getClickTabs} editPageCancelBtnClick={editPageCancelBtnClick} currentForm={form} editData={detailData}></ScheduleAndChargeEdit>

        }
        </>
    )
}

export default ScheduleAndCharge;

